export default function initGroupSearch() {
    document.addEventListener("alpine:init", () => {
        Alpine.store("groupSearch", {
            open: false,
            items: [],
            filter: "",
            selectedGroup: null,
            selectedLabel: null,

            toggle() {
                this.open = !this.open;
            },
            select(value, key) {
                if (this.selectedGroup == key) {
                    this.selectedLabel = null;
                    this.selectedGroup = null;
                } else {
                    this.selectedLabel = value;
                    this.selectedGroup = key;
                    this.open = false;
                }
            },
            isSelected(key) {
                return this.selectedGroup == key;
            },
            searchGroups(filter) {
                fetch(`/groups/search?q=${filter}`)
                    .then((res) => res.json())
                    .then((data) => {
                        this.items = data.results;
                        this.open = true;
                    });
            },
        });
    });
}
